import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { ContentChecker } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/content-checker")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <ContentChecker />
    </RouteGuard>
  ),
});
